<template>
  <!-- 消耗品発送指示 -->
  <div id="AppDisposablesOrder">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="columns" style="margin-left: 100px; margin-Right: 100px;">
      <div class="column is-full">
        <label class="searchTitle label">消耗品発送指示</label>
      </div>
    </div>
    <!-- 詳細表示 -->
    <div class="columns" style="margin-left: 100px; margin-Right: 100px;">
      <div class="column is-full detailArea">
        <div>
          <b-table :data="productDispoables" class="is-full">
            <template slot-scope="props">
              <template v-if="currentProductName">
                <tr>
                  <td style="border-bottom: solid 1px;width:200px">
                    <div class="notice title is-6">
                      {{currentProductName}}
                      <br />
                      ({{currentProductSerialNumber}})
                    </div>
                  </td>
                  <td style="border-bottom: solid 1px;">
                    <table v-for="(disposable, index) in props.row.disposables" v-bind:key="index">
                      <tr>
                        <td style="width:250px;">
                          <b-input v-model="disposable.productCode" :readOnly="true"></b-input>
                        </td>
                        <td style="width:300px;">
                          <span
                            style="margin-left:10px;"
                          >{{disposable.productCode | disposableFilter(productMaster) }}</span>
                        </td>
                        <td style="width:150px;">
                          <div style="float:right">
                            <b-field
                              :type="{'is-danger': errors.has(getFieldEaName(disposable,index,'0'))}"
                              :message="errors.first(getFieldEaName(disposable,index,'0'))"
                            >
                              <b-input
                                :name="getFieldEaName(disposable,index,'0')"
                                data-vv-as="個数"
                                type="number"
                                style="width:100px;"
                                min="0"
                                max="999"
                                v-validate="`numeric`"
                                v-model="disposable.count"
                              ></b-input>
                              <span style="margin-left:10px;">EA</span>
                            </b-field>
                          </div>
                        </td>
                        <td style="width:200px;">
                          <div style="float:right">
                            <b-field
                              :type="{'is-danger': errors.has(getFieldEaName(disposable,index,'1'))}"
                              :message="errors.first(getFieldEaName(disposable,index,'1'))"
                            >
                              <b-datepicker
                                v-model="disposable1PreDate"
                                name="disposable1PreDate"
                                data-vv-as="次回供給予定日"
                                placeholder="次回供給予定日"
                                icon="calendar-today"
                                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                                :day-names="['日','月','火','水','木','金','土']"
                              >
                                <button class="button is-danger" @click="disposable1PreDate = null">
                                  <b-icon icon="close"></b-icon>
                                  <span>Clear</span>
                                </button>
                              </b-datepicker>
                              <span style="margin-left:10px;"></span>
                            </b-field>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </template>
            </template>
          </b-table>
          <b-table :data="additionalDispoables" class="is-full">
            <template slot-scope="props">
              <tr>
                <td style="border-bottom: solid 1px; width:200px" :rowspan="props.row.length">
                  <div class="notice title is-6">消耗品</div>
                </td>
                <td style="border-bottom: solid 1px;">
                  <table v-for="(disposable,index) in props.row.disposables" v-bind:key="index">
                    <tr>
                      <td style="width:250px;">
                        <b-autocomplete
                          type="hidden"
                          :name="getFieldCodeName(disposable,index)"
                          :id="getFieldCodeName(disposable,index)"
                          data-vv-as="消耗品コード"
                          :data="filteredProduct"
                          v-model="disposable.productCode"
                          field="productCode"
                          v-validate="`${disposable.count && disposable.count !=0 ? 'required' : ''}|chackDisposable`"
                          @select="option => {disposable.productCode = option.productCode;
                          errors.remove(getFieldCodeName(disposable,index))}"
                          @typing="filteredProductList(disposable.code)"
                        >
                          <template slot-scope="props">
                            <div>{{ props.option.key }}</div>
                          </template>
                        </b-autocomplete>
                      </td>
                      <td style="width:300px;">
                        <b-field
                          :type="{'is-danger': errors.has(getFieldCodeName(disposable,index))}"
                          :message="errors.first(getFieldCodeName(disposable,index))"
                        ></b-field>
                        <span
                          style="margin-left:10px;"
                        >{{disposable.productCode | disposableFilter(disposablesMaster) }}</span>
                      </td>
                      <td style="width:100px;">
                        <div style="float:right">
                          <b-field
                            :type="{'is-danger': errors.has(getFieldEaName(disposable,index,'1'))}"
                            :message="errors.first(getFieldEaName(disposable,index,'1'))"
                          >
                            <b-input
                              :name="getFieldEaName(disposable,index,'1')"
                              style="width:100px;"
                              data-vv-as="個数"
                              type="number"
                              min="0"
                              max="999"
                              v-model="disposable.count"
                              v-validate="`${disposable.productCode ? 'required' : ''}|numeric|max_value:999`"
                            ></b-input>
                            <span style="margin-left:10px;">EA</span>
                          </b-field>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td style="border-bottom: solid 1px;width:200px">
                  <div class="notice title is-6">指定納期</div>
                </td>
                <td style="border-bottom: solid 1px;">
                  <b-field
                    :type="{'is-danger':errors.has('deliveryDate')}"
                    :message="errors.first('deliveryDate')"
                  >
                    <b-datepicker
                      v-model="deliveryDate"
                      :min-date="minDate"
                      align="right"
                      placeholder="指定納期"
                      data-vv-as="指定納期"
                      name="deliveryDate"
                      v-validate="'required'"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                    ></b-datepicker>
                  </b-field>
                </td>
              </tr>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppDisposablesOrder",
  props: ["patientCode", "items", "replaceProductName"],
  methods: {
    getItems: function() {
      // 親画面から呼ばれる
      // 個数が「1」以上のものだけ返却
      var returnItems = [];
      var additionalDispoable = this.additionalDispoables[0];
      var productDispoable = this.productDispoables[0];
      for (var i = 0; i < additionalDispoable.disposables.length; i++) {
        if (additionalDispoable.disposables[i]["count"] != null) {
          returnItems.push({
            code: this.currentProductCode,
            productCode: additionalDispoable.disposables[i].productCode,
            count: additionalDispoable.disposables[i].count,
            deliveryDate: this.formatDate(this.deliveryDate)
          });
        }
      }
      for (var k = 0; k < productDispoable.disposables.length; k++) {
        if (productDispoable.disposables[k]["count"] != null) {
          returnItems.push({
            code: this.currentProductCode,
            productCode: productDispoable.disposables[k].productCode,
            count: productDispoable.disposables[k].count,
            deliveryDate: this.formatDate(this.deliveryDate)
          });
        }
      }
      return returnItems;
    },
    getFieldCodeName: function(disposable, index) {
      return "消耗品コード：" + disposable + index;
    },
    getFieldEaName: function(disposable, index, sub) {
      return "個数：" + disposable + sub + index;
    },
    getDeliveryName: function(value) {
      var deliveryElement = this.disposablesMaster.find(
        v => v.productCode === value
      );
      if (deliveryElement) {
        return deliveryElement.productName;
      }
      return "";
    },
    filteredProductList: function(inputValue) {
      //選択候補を絞り込む
      this.filteredProduct = this.disposablesMaster.filter(option => {
        var retValue =
          option.key
            .toString()
            .toLowerCase()
            .indexOf(inputValue.toLowerCase()) >= 0;
        return retValue;
      });
      //未選択用の選択肢を追加する
      this.filteredProduct.unshift({
        key: "　",
        productCode: "",
        productName: ""
      });
    }
  },
  data() {
    var currentProductCode = "";
    var currentProductName = "";
    var currentProductSerialNumber = "";
    var disposablesMaster = [];
    this.getDeliveryList(disposablesMaster);
    var productMaster = [];
    this.getProductList(productMaster);
    var productDispoables = [
      {
        disposables: []
      }
    ];
    var deliveryHistory = this.items.deliveryHistory;
    var additionalDispoables = [
      {
        disposables: []
      }
    ];
    var minDate = new Date();
    minDate.setDate(minDate.getDate() - 1);
    var appointmentCode = this.$props.appointmentCode;
    return {
      appointmentCode,
      productDispoables,
      additionalDispoables,
      disposablesMaster,
      productMaster,
      deliveryDate: null,
      deliveryHistory,
      currentProductCode,
      currentProductName,
      currentProductSerialNumber,
      filteredProduct: [],
      minDate
    };
  },
  mounted: function() {
    if (this.$props.replaceProductName) {
      this.currentProductCode = this.items.machineReplaceProductCode;
      this.currentProductName = this.$props.replaceProductName;
    } else {
      this.currentProductCode = this.items.productCode;
      this.currentProductName = this.items.productName;
    }
    this.currentProductSerialNumber = this.items.serialNumber;
    for (var dispo in this.items.deliveryHistory) {
      // 指定納期取得
      if (this.items.deliveryHistory[dispo].deliveryDate) {
        this.deliveryDate = this.parseDate(
          this.items.deliveryHistory[dispo].deliveryDate
        );
      }
      if (this.items.deliveryHistory[dispo].machineFlag) {
        this.productDispoables[0].disposables.push(
          this.items.deliveryHistory[dispo]
        );
      } else {
        this.additionalDispoables[0].disposables.push(
          this.items.deliveryHistory[dispo]
        );
      }
    }
    var target = 10 - this.additionalDispoables[0].disposables.length;
    for (var i = 0; i < target; i++) {
      this.additionalDispoables[0].disposables.push({
        code: "",
        count: null
      });
    }
  },
  filters: {
    disposableFilter: function(value, disposablesMaster) {
      var product = disposablesMaster.find(v => v.productCode === value);
      if (product) {
        return product.productName + " (" + product.productCode + ")";
      }
      return "";
    }
  },
  components: {},
  computed: {},
  created: function() {
    this.$validator.extend("chackDisposable", {
      getMessage: field => `入力された消耗品コードは存在しません。`,
      validate: value => {
        var ret = true;
        // 入力値チェック
        if (this.getDeliveryName(value) == "") {
          var ret = false;
        }
        return ret;
      }
    });
  }
};
</script>
<style lang="scss">
.autocomplete > .dropdown-menu > .dropdown-content {
  width: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/AppDisposablesOrder.vue